import moment from 'moment-timezone';

import { CurrentUser } from '../../../../../rematch-models/user';

const TIME_ONLY_FORMAT = 'h:mm';
const DAY_FORMAT = 'D';
const FULL_DATETIME_FORMAT = `ddd, MMMM ${DAY_FORMAT}, YYYY [at] ${TIME_ONLY_FORMAT}`;
const MONTH_FORMAT = 'MMM';

const toMomentTimezone = (date: Date, user: CurrentUser) =>
  moment.tz(moment(date).toISOString(), user.localTimezone);

export const formatSessionTimeForDisplay = ({
  endTime,
  startTime,
  user,
}: {
  endTime: Date;
  startTime: Date;
  user: CurrentUser;
}) => {
  const momentStartTime = toMomentTimezone(startTime, user);
  const momentEndTime = toMomentTimezone(endTime, user);

  let startTimeFormat = FULL_DATETIME_FORMAT;

  const isOnSameDay = momentStartTime.isSame(momentEndTime, 'day');

  let formattedEndTime;
  if (isOnSameDay) {
    formattedEndTime = momentEndTime.format(`${TIME_ONLY_FORMAT} a z`);
  } else {
    formattedEndTime = momentEndTime.format(`${FULL_DATETIME_FORMAT} a z`);
  }

  if (!isOnSameDay || momentStartTime.format('a') !== momentEndTime.format('a')) {
    startTimeFormat = `${startTimeFormat} a`;
  }

  const formattedStartTime = momentStartTime.format(startTimeFormat);

  return `${formattedStartTime} - ${formattedEndTime}`;
};

export const getMonthAndDayFromSessionStartTime = (startTime: Date) => {
  const momentStartTime = moment(startTime);

  return {
    day: momentStartTime.format(DAY_FORMAT),
    month: momentStartTime.format(MONTH_FORMAT),
  };
};
